// Tab types
export type IntegrationsTab = 'active' | 'available';

// Sub-tab types for Available tab
export type IntegrationsSubTab =
  | 'accounting'
  | 'billing'
  | 'financial-institution'
  | 'document-storage';

// Default values
export const DEFAULT_SUB_TAB: IntegrationsSubTab = 'accounting';

// URL constants
export const integrationsURLs = {
  // Base path
  base: '/central-data-hub/integrations',
  _base_relative_path: 'integrations',

  // Active integrations
  active: '/central-data-hub/integrations/active',
  _active_relative_path: 'active',

  // Available integrations (sub-tabs use query params)
  available: '/central-data-hub/integrations/available',
  _available_relative_path: 'available',

  // Helper to build available sub-tab URL with query param
  availableSubTab: (subTab: IntegrationsSubTab) =>
    `/central-data-hub/integrations/available?tab=${subTab}`,
} as const;
